import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { GeneralProductsProducts } from 'src/app/services/service/DataProviders/GeneralProductsProducts';

@Component({
  selector: 'product-structure',
  templateUrl: './product-structure.component.html',
  styleUrls: ['./product-structure.component.scss']
})
export class ProductStructureComponent implements OnInit {

  public tehnologieChoose;
  public productTypeChoose;
  public productTypeGroupedChoose;

  public filterForm: FormGroup;
  public partNumber = null;
  public quantity: number = 1;

  public tree = [];

  public processRecipe = false;
  public recepiesToProcess = [];

  constructor(private productService: GeneralProductsProducts) {
    this.createFilterForm();
  }

  ngOnInit() {
  }

  async loadTree() {
    this.processRecipe = false;
    this.tree = [];
    this.recepiesToProcess = [];
    if (!_.isEmpty(this.filterForm.value.PartNumber)) {
      this.partNumber = _.get(this.filterForm, 'value.PartNumber');
      this.quantity = _.get(this.filterForm, 'value.quantity', 1);

      let theProduct = null;
      let result = await this.productService.findProduct(this.partNumber).pipe(take(1)).toPromise();

      if (_.has(result, 'value[0]')) {
        theProduct = _.get(result, 'value[0]')
      }

      if (theProduct === null) {
        return true;
      }

      let recipe = {
        Recipe: {
          Product: theProduct
        },
        ProducedQuantityBase: {
          Value: this.quantity
        }
      };

      this.recepiesToProcess.push(recipe);
      this.processRecipe = true;
    }
  }

  private createFilterForm() {
    this.filterForm = new FormGroup({
      PartNumber: new FormControl('', [ //0320050000012
        Validators.required
      ]),
      quantity: new FormControl(1 , [
        Validators.required
      ])
    });
  }

  resetForm() {
    this.processRecipe = false;
    this.tree = [];
    this.recepiesToProcess = [];
    this.filterForm.reset();
  }


}
